exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-update-panel .news-panel-list ul li .list-news-update {\n  border: 0;\n  padding: 0;\n  background-color: transparent;\n  padding-top: 4px;\n}\n\n.news-update-panel .news-panel-list ul li:last-child {\n  margin-bottom: 12px;\n}\n\n.dashboard .dashboard__carousel .slick-arrow.slick-prev, .dashboard .dashboard__carousel .slick-arrow.slick-next {\n  opacity: 1;\n}\n\n.slick-slider.dashboard__carousel.slick-initialized {\n  position: relative;\n}\n\n.news-update-panel .news-panel-title {\n  padding: 10px 15px 0 15px;\n  border-bottom: none;\n}\n\n.news-update-panel .news-panel-list {\n  margin-top: 4px;\n}\n", ""]);

// exports
